import {
  TRESPONSE_GET_TNA_ORDER_STEP_LIST,
  TRESPONSE_GET_TNA_ORDER_STEP,
  TTnaOrderStepFetchReason,
  TUserPaginationOption,
} from '@monorepo/types';

export type TTnaUpdateState = {
  tnaOrderStepList: {
    tnaStepList: TRESPONSE_GET_TNA_ORDER_STEP_LIST;
    fetchReason: TTnaOrderStepFetchReason;
  } | null;
  tnaOrderStep: {
    tnaStep: TRESPONSE_GET_TNA_ORDER_STEP;
    tosId: TRESPONSE_GET_TNA_ORDER_STEP_LIST['tnaOrderStepItemList'][number]['tosId'];
  } | null;
  userPaginationOption: TUserPaginationOption;
};

export const TTnaUpdateActionType = {
  GetTnaOrderStepList: 'GET_TNA_ORDER_STEP_LIST ' as const,
  GetTnaOrderStepListSuccess: 'GET_TNA_ORDER_STEP_LIST_SUCCESS' as const,
  GetTnaOrderStepListFailure: 'GET_TNA_ORDER_STEP_LIST_FAILURE' as const,
  GetTnaOrderStep: 'GET_TNA_ORDER_STEP ' as const,
  GetTnaOrderStepSuccess: 'GET_TNA_ORDER_STEP_SUCCESS' as const,
  GetTnaOrderStepFailure: 'GET_TNA_ORDER_STEP_FAILURE' as const,
  UpdateTnaOrderStep: 'UPDATE_TNA_ORDER_STEP' as const,
  UpdateTnaOrderStepSuccess: 'UPDATE_TNA_ORDER_STEP_SUCCESS' as const,
  UpdateTnaOrderStepFailure: 'UPDATE_TNA_ORDER_STEP_FAILURE' as const,
  BulkCompleteTnaOrderSteps: 'BULK_COMPLETE_TNA_ORDER_STEPS' as const,
  BulkCompleteTnaOrderStepsFailure: 'BULK_COMPLETE_TNA_ORDER_STEPS_FAILURE' as const,
  SetUserPaginationOption: 'SET_TNA_ORDER_USER_PAGINATION_OPTION' as const,
};
